import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteSpinGame,
	fetchSpinGame,
	resetDeleteStatusSpinGame,
	updateSpinGame,
} from "../../../actions/spinTheWheelGame";

import "../Question.scss";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import SpinGameForm from "../../Forms/spinTheWheelGame";
import { DateFormat, DateTimeFormat } from "../../../helpers/utils";
import moment from "moment";

const SpinGamePage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [spinGameId, setSpinGameId] = useState(null);
	const { status, spinGame } = useSelector((state) => state.fetchSpinGame);
	const { status: updateStatus } = useSelector((state) => state.updateSpinGame);
	const { spinGameDeleted } = useSelector((state) => state.deleteSpinGame);
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameId(null);
	};

	const handleEdit = () => {
		showModal();
		setSpinGameId(spinGame.id);
		form.setFieldsValue({
			...spinGame,
			start_date: moment(spinGame.start_date).utcOffset("+08:00"),
			end_date: moment(spinGame.end_date).utcOffset("+08:00"),
			redeem_expiry_date: moment(spinGame.redeem_expiry_date).utcOffset(
				"+08:00",
			),
		});
	};

	const handleDelete = () => {
		dispatch(deleteSpinGame(spinGameId));
	};

	const handleSubmitForm = (values) => {
		const newValues = values;
		newValues.start_date = values.start_date
			? moment(values.start_date).format("DD/MM/YYYY")
			: null;
		newValues.end_date = values.end_date
			? moment(values.end_date).format("DD/MM/YYYY")
			: null;
		newValues.redeem_expiry_date = values.redeem_expiry_date
			? moment(values.redeem_expiry_date).format("DD/MM/YYYY")
			: null;
		if (spinGameId) {
			dispatch(updateSpinGame(spinGameId, newValues));
		}
		handleOk();
	};

	useEffect(() => {
		if (status === "IDLE") {
			dispatch(fetchSpinGame(id));
		}
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchSpinGame(id));
	}, [updateStatus]);

	useEffect(() => {
		if (spinGameDeleted) {
			history.push("/spin-the-wheel/games");
			dispatch(resetDeleteStatusSpinGame());
		}
	}, [spinGameDeleted]);

	useEffect(() => {
		if (spinGame && spinGame.id === Number(id)) {
			setSpinGameId(spinGame.id);
		} else {
			setSpinGameId();
		}
	}, [spinGame]);

	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Game Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/spin-the-wheel/games">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Name</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinGame.name}
										</div>
									</div>
									<div className="details-item">
										<label>Total Chances</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinGame.total_chances}
										</div>
									</div>
									<div className="details-item">
										<label>Start Date</label>
										<div className="text">
											{DateFormat(spinGame.start_date)}
										</div>
									</div>
									<div className="details-item">
										<label>End Date</label>
										<div className="text">{DateFormat(spinGame.end_date)}</div>
									</div>
									<div className="details-item">
										<label>Redeem Expiry Date</label>
										<div className="text">
											{DateFormat(spinGame.redeem_expiry_date)}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{DateTimeFormat(spinGame.updated_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="spin-form-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<SpinGameForm
					form={form}
					spinGameId={spinGameId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default SpinGamePage;
